import { Stack } from 'components/Stack';
import { LineItem } from '../LineItem';
import { SelectedLineItem, ReturnLineItem } from '../../../../../../interfaces';

interface LineItemsSectionProps {
  selectedLineItems: SelectedLineItem;
}

export const LineItemsSection = ({
  selectedLineItems,
}: LineItemsSectionProps): JSX.Element => {
  return (
    <Stack direction="column" gap={16}>
      {Array.from(selectedLineItems.values()).map(
        (returnLineItem: ReturnLineItem) => (
          <LineItem returnLineItem={returnLineItem} />
        ),
      )}
    </Stack>
  );
};
